import React from "react";
import { User, X, Pencil } from "lucide-react";
import { Combobox, Avatar } from "@/components/ui";
import { useShareFormLink } from "../context/ShareFormLinkContext";
import { extractInitials } from "@/utils/helpers";

export function QuickCreateFanForm() {
  const { setCreatedFan, fans, activeFanSelected, setIsCreateFanOpen } = useShareFormLink();

  const handleClearSelection = () => {
    setCreatedFan(null);
    fans.onValueChange(null as any, undefined);
  };

  return (
    <div className="flex flex-col gap-3 w-full animate-in fade-in duration-200">
      {activeFanSelected ? (
        <div className="flex flex-col gap-3 w-full">
          <div className="flex items-center justify-between bg-white border border-slate-200 rounded-xl p-3.5 text-left">
            <div className="flex items-center gap-3 min-w-0 flex-1">
              <Avatar size="lg">
                <Avatar.Image src={activeFanSelected.original?.avatarUrl || undefined} />
                <Avatar.Fallback className="bg-primary/10 text-primary font-bold">
                  {activeFanSelected.original?.displayName ? (
                    extractInitials(activeFanSelected.original.displayName)
                  ) : (
                    <User className="size-5" />
                  )}
                </Avatar.Fallback>
              </Avatar>
              <div className="flex flex-col min-w-0">
                <span className="text-sm font-bold text-slate-800 truncate">
                  {activeFanSelected.label.split(" - ")[0]}
                </span>
                {activeFanSelected.label.includes(" - ") && (
                  <span className="text-xs text-slate-400 font-medium truncate mt-1 leading-none">
                    {activeFanSelected.label.split(" - ")[1]}
                  </span>
                )}
              </div>
            </div>
            <div className="flex items-center gap-1">
              <button
                type="button"
                onClick={() => setIsCreateFanOpen(true)}
                className="p-1.5 hover:bg-slate-50 rounded-md text-slate-400 hover:text-primary transition-colors border-none bg-transparent cursor-pointer"
                title="Edit fan details"
              >
                <Pencil className="size-4" />
              </button>
              <button
                type="button"
                onClick={handleClearSelection}
                className="p-1.5 hover:bg-slate-50 rounded-md text-slate-400 hover:text-rose-500 transition-colors border-none bg-transparent cursor-pointer"
                title="Clear selection"
              >
                <X className="size-4.5" />
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col gap-2 w-full">
          <Combobox
            {...fans}
            placeholder="Search existing clients or add a new one..."
            className="w-full bg-white text-sm animate-in fade-in duration-200"
          />
        </div>
      )}
    </div>
  );
}
